// Feature flag for new in-chat escalation system
// When false, behavior matches main exactly (Intercom popup)
// When true, uses new in-chat human support with SSE streaming
export const USE_IN_CHAT_ESCALATION = false;
